import { IPagingSettings, ISortingSettings } from '@module/shared/components/Site/models';
import { requestSiteGet } from '@service/siteDataService';
import { SERVIS_SITE_PAGING_CHANGE } from '../../registerSite/actionCreators/registerSiteActionCreators';
export const SITE_GET_REQUEST = 'SITE_GET_REQUEST';
export const SITE_GET_SUCCESS = 'SITE_GET_SUCCESS';
export const SITE_GET_ERROR = 'SITE_GET_ERROR';
export const SITE_PAGING_CHANGE = 'SITE_PAGING_CHANGE';
export const SITE_SORT_CHANGE = 'SITE_SORT_CHANGE';
export const SITE_APPLY_SEARCH = 'SITE_APPLY_SEARCH';
export const SITE_SEARCH_CHANGE = 'SITE_SEARCH_CHANGE';

export function onSiteGetRequest(pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) {
    return (dispatch: any) => {
        makeSiteGetRequest(dispatch, pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}

export function onSiteResponseSuccess(response: any) {
    return {
        type: SITE_GET_SUCCESS,
        sites: response.sites,
        totalNumberOfSites: response.totalCount
    };
}

export function onSiteResponseError() {
    return {
        type: SITE_GET_ERROR,
        text: 'Error receiving data'
    };
}

export async function makeSiteGetRequest(dispatch: any, pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) {
    dispatch({ type: SITE_GET_REQUEST });
    try {
        const sites = await requestSiteGet(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
        dispatch(onSiteResponseSuccess(sites));
    } catch (error) {
        console.error('Site get request failed', error);
        dispatch(onSiteResponseError());
    }
}

export function onPagingChange(pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) {
    return (dispatch: any) => {
        dispatch({ type: SITE_PAGING_CHANGE, pagingSettings, sortingSettings });
        makeSiteGetRequest(dispatch, pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}

export function onServIsPagingChange(pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) {
    return (dispatch: any) => {
        dispatch({ type: SERVIS_SITE_PAGING_CHANGE, pagingSettings, sortingSettings });
        makeSiteGetRequest(dispatch, pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}
export function onSortingChange(pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) {
    return (dispatch: any) => {
        const newPagingSettings = { ...pagingSettings, skipItems: 0 };
        dispatch({ type: SITE_SORT_CHANGE, pagingSettings, sortingSettings });
        makeSiteGetRequest(dispatch, newPagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}

export function onFilterFieldChange(searchFilter: string) {
    return {
        type: SITE_SEARCH_CHANGE,
        searchFilter
    };
}

export function onFilterApplied(searchFilter: string, pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, fromServIs: boolean, accessToken: string) {
    return (dispatch: any) => {
        const newPagingSettings = { ...pagingSettings, skipItems: 0 };
        dispatch({ type: SITE_APPLY_SEARCH, searchFilter });
        dispatch({ type: SITE_PAGING_CHANGE, pagingSettings: newPagingSettings, sortingSettings });
        makeSiteGetRequest(dispatch, newPagingSettings, sortingSettings, searchFilter, fromServIs, accessToken);
    };
}
